<script lang="ts">
export default {
  name: 'EaSimpleCheckbox',
  inheritAttrs: false,
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  label?: string | null
  modelValue?: string | number | boolean | Array<any>
  value?: string | number
  name?: string
  disabled?: boolean
  asSwitch?: boolean
  index?: string | number
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: null,
  modelValue: null,
  value: null,
  name: '',
  disabled: false,
  asSwitch: false,
  index: '',
  size: '',
})

interface Emits {
  (event: 'update:modelValue', value: boolean): void
}
const emit = defineEmits<Emits>()

const inputId = computed(() => {
  return `${props.name || ''}${props.index.toString().length ? '.' + props.index : ''}`
    .toLowerCase()
    .replace(/\W+/gi, '-')
})

function onCheckedChange(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).checked)
}
</script>

<template lang="pug">
.form-check(:class="{ 'form-switch': asSwitch, [size]: !!size }")
  input.form-check-input(
    :checked="!!modelValue"
    :disabled="disabled"
    :id="inputId"
    :name="name"
    :value="value"
    @change="onCheckedChange"
    type="checkbox"
  )
  label.form-check-label(v-if="label" :for="inputId")
    slot(name="label") {{ label }}
</template>
